import React from 'react';
import {Route} from 'react-router-dom';
import MainLayout from '../main';
import EmptyLayout from '../empty';
import {check} from "../../../utils/tokenUtils";

const ContentLayout = (props) => <Route render={matchProps => (
  check() ? <MainLayout private {...props}/> : <EmptyLayout {...props}/>
)}/>;

export default ContentLayout;



// WEBPACK FOOTER //
// ./src/components/layout/content-layout/content-layout.jsx